import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Typo } from "@/model";
import typoRepository from "@/repository/typoRepository";
import { typoQueryKeys } from "./keys";


interface DeleteTypoProps {
    ids?: string[];
    keyword?: string;
}

export const useDeleteTypo = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Typo, AxiosError, DeleteTypoProps>({
        mutationKey: ["typo", "agent", agentId, "delete"],
        mutationFn: async (props: DeleteTypoProps) => {
            try {
                const res = await typoRepository.deleteMany(agentId, props.ids, props.keyword);
                return res.data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: typoQueryKeys.all(agentId)
            });
        }
    });
};
